import { render, staticRenderFns } from "./VersionIndexDetailDialog.vue?vue&type=template&id=d4b9771a&scoped=true&"
import script from "./VersionIndexDetailDialog.vue?vue&type=script&lang=js&"
export * from "./VersionIndexDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./VersionIndexDetailDialog.vue?vue&type=style&index=0&id=d4b9771a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9771a",
  null
  
)

export default component.exports